import type { VoiceMessage } from '../api/types';
import './VoiceItem.css';

interface Props {
  voice: VoiceMessage;
  isActive: boolean;
  isPlaying: boolean;
  onToggle: () => void;
}

function formatDuration(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}

function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(iso));
}

export function VoiceItem({ voice, isActive, isPlaying, onToggle }: Props) {
  return (
    <article className={`voice-item ${isActive ? 'voice-item--active' : ''} ${voice.isLocked ? 'voice-item--locked' : ''}`}>
      <button
        type="button"
        className="voice-item-play"
        onClick={onToggle}
        aria-label={voice.isLocked ? 'Open access prompt' : isPlaying ? 'Pause message' : 'Play message'}
      >
        {voice.isLocked ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        ) : isActive && isPlaying ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <rect x="6" y="4" width="4" height="16" rx="1" />
            <rect x="14" y="4" width="4" height="16" rx="1" />
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="5,3 19,12 5,21" />
          </svg>
        )}
      </button>

      <button type="button" className="voice-item-info" onClick={onToggle}>
        <span className="voice-item-title">{voice.title}</span>
        <span className="voice-item-meta">
          {formatDate(voice.createdAt)} • {formatDuration(voice.duration)}
          {voice.categoryName ? ` • ${voice.categoryName}` : ''}
        </span>
      </button>

      {voice.isLocked ? (
        <span className="voice-item-badge">Subscribers</span>
      ) : voice.isPreview ? (
        <span className="voice-item-badge voice-item-badge--preview">Preview</span>
      ) : null}
    </article>
  );
}
